import React from 'react';
import style from './style.module.scss';
import {Label as ProductLabel, renderLabelTooltip} from '../Label';
import {Typography} from 'components/Typography';
import {IProductSnippet, TProductLabel} from 'shared/types/productSnippet.types';

type TIsNewLabelProps = TProductLabel &
    Pick<IProductSnippet, 'id'> &
    Pick<IProductSnippet['analytics'], 'onStockClick'>;

export const IsNewLabel = (props: TIsNewLabelProps) => {
    const {code, title, id, url, tooltip, onStockClick} = props;

    return (
        <ProductLabel className={style.main} key={code} id={id} url={url} tooltip={renderLabelTooltip(tooltip)}>
            <Typography
                onClick={() => {
                    onStockClick(url);
                }}
                variant={'label-12-r'}
            >
                {title}
            </Typography>
        </ProductLabel>
    );
};
